/* tslint:disable */
import * as React from 'react';
import {Field, FieldArray, formValueSelector, reduxForm, InjectedFormProps, submit} from 'redux-form';
import {flow, map, forEach, size, difference, isEmpty, find, get} from 'lodash';
import {II18nMessages} from '../../../../services/branding/models';
import {Button, Col, ControlLabel, Form, FormGroup, Row, Modal} from 'react-bootstrap';
import FieldFormControl from '../../../../components/FieldFormControl';
import SelectControl from '../../../../components/SelectControl';
import Destination from './components/Destination';
import CruiseQuestion from './components/CruiseQuestion/CruiseQuestion';
import {connect} from 'react-redux';
import AlternativeDatePicker from '../../../../components/AlternativeDatePicker/index';
// import RadioBooleanControl from '../../../../components/RadioBooleanControl/index';
import {
  IChannel, IDestination, IProduct, IOccupation, IIndustry,
  IPolicyApplication, ITraveller,
} from '../../../../data/api/models';
import {
  isFutureDate, isRequired, isValidDate, annualLimit, singleLimit, singleMaxTripDuration, isNotFalse,
} from '../../../../util/validators';
import * as moment from 'moment';
import {showDestinations, showRegions} from '../../../../data/api/api';
import {actions as quoteActions, getInitValues} from '../../../../services/quote/reducer';
import {IAuthState} from '../../../../services/auth/models';
import {bindActionCreators} from 'redux';
import {IQuoteActions} from '../../../../services/quote/models';
import Travellers from './components/Travellers';
import FaCheck from 'react-icons/fa/check';
import FaChevronRight from 'react-icons/fa/chevron-right';
import VoucherCode from '../../components/VoucherCode';
import MarketingOptions from '../../components/MarketingOptions';
import {IStore} from '../../../../redux/IStore';
import GroupType from './components/GroupType/GroupType';
import GroupTypeSelected from './components/GroupType/GroupTypeSelected';
import MaxTripDuration from './components/MaxTripDuration/MaxTripDuration';
import CovidStatement from './components/CovidStatement';

interface ITripDetailsFormProps extends InjectedFormProps {
  destinations: IDestination[];
  occupations: IOccupation[];
  industries: IIndustry[];
  auth: IAuthState;
  i18n: II18nMessages;
  travellers: ITraveller[];
  groupType: string;
  cruiseCover: boolean;
  tripType: string;
  startDate: string;
  region: string;
  maxTripDuration: string;
  schemeId: string;
  endDate: string;
  dispatch: any;
  product: IProduct;
  destinationsValue: string[];
  occupationValue: string[];
  industryValue: string[];
  policyConsent: boolean;
  channel: IChannel;
  quote: IPolicyApplication;
  infoConsent: boolean;

  renderDefinition(name: string): any;

  actions: {
    quote: IQuoteActions;
    submit(name: string);
  };
}

interface ITripDetailsStates {
  showBlockerModal: boolean;
  modalMessage: string;
}

class TripDetailsForm extends React.Component<ITripDetailsFormProps, ITripDetailsStates> {
  public state = {
    showBlockerModal: false,
    modalMessage: '',
  };

  public componentWillMount() {
    const {product, change, initialValues, dispatch, channel, auth} = this.props;

    const data = getInitValues(product, null, null);

    forEach(data, (value, key) => {
      if (initialValues[key] === null) {
        change(key, value);
      }
    });

    const dateFromApi = (date) => {
      if (!date) {
        return '';
      }

      const parsedDate = moment(date).format('DD/MM/YYYY');

      return parsedDate !== 'Invalid Date' ? parsedDate : '';
    };

    dispatch(change('salesChannel', channel.key));
    dispatch(change('quotationTypes', 'Direct'));
    dispatch(change('residency', 'uk'));
    dispatch(change('emailSend', false));

    if (auth.isAuthenticated) {
      dispatch(change('travellers[0].title', auth.customer.title));
      dispatch(change('travellers[0].dob', dateFromApi(auth.customer.dob)));
      dispatch(change('travellers[0].firstName', auth.customer.firstName));
      dispatch(change('travellers[0].lastName', auth.customer.lastName));
      dispatch(change('travellers[0].email', auth.customer.email));
      dispatch(change('travellers[0].phone', auth.customer.phone1));
      dispatch(change('travellers[0].address.postcode', auth.customer.address.postcode));
      dispatch(change('travellers[0].address.line1', auth.customer.address.line1));
      dispatch(change('travellers[0].address.line2', auth.customer.address.line2));
      dispatch(change('travellers[0].address.town', auth.customer.address.town));
      dispatch(change('travellers[0].address.country', auth.customer.address.country));
    }
  }

  public componentDidUpdate() {
    const {tripType, dispatch, change, product} = this.props;
    let regionTripType = tripType;

    if (product.productCode === 'LSB') {
      regionTripType = 'longstay';
    }

    if (regionTripType === 'single') {
      dispatch(change('region', ''));
      dispatch(change('maxTripDuration', ''));
    }

    if (regionTripType === 'annual') {
      dispatch(change('destinations', ''));
      dispatch(change('endDate', ''));
      if (size(get(product, 'metadata.annual_trip_durations', {})) === 1) {
        dispatch(change('maxTripDuration', Object.keys(product.metadata.annual_trip_durations)[0]));
      }
    }

    if (regionTripType === 'longstay') {
      dispatch(change('destinations', ''));
      dispatch(change('maxTripDuration', ''));
    }
  }

  private getAge = (dob) => {

    if (isEmpty(dob)) {
      return null;
    }

    const convertedDate = dob.split(/\//).reverse().join('/');
    return moment().diff(convertedDate, 'years');
  }

  public componentWillReceiveProps(nextProps) {
    const {tripType, dispatch, change, actions, schemeId} = this.props;

    if (schemeId && tripType !== nextProps.tripType) {
      dispatch(change('schemeId', ''));
      actions.quote.calculate(null, true);
    }
  }

  public renderAboutUs = () => {
    const {channel} = this.props;
    const TERMS_OF_BUSINESS = 'Terms of Business';
    const aiosDocument = find(channel.productDocuments, (document) => {
      return document.shortName === TERMS_OF_BUSINESS;
    });
    const aboutUsUrl = aiosDocument ? aiosDocument.filePath : '';

    let privacyUrl = 'https://www.freespirittravelinsurance.com/privacy';

    if(['ven-b2c'].includes(channel.key)) {
      privacyUrl = "https://venturesure.co.uk/documents/Socprivacypolicy.pdf";
    }

    if(['tpl-b2c'].includes(channel.key)) {
      privacyUrl = "https://www.travelpluscover.co.uk/documents/Socprivacypolicy.pdf";
    }

    if(['lsb-b2c'].includes(channel.key)) {
      privacyUrl = "https://www.pjhayman.com/documents/important_documents/PJH_Privacy_policy.pdf";
    }

    if (['fst-b2c', 'tpl-b2c', '247-b2c', 'ven-b2c'].includes(channel.key)) {
      return (
        <div>
          <div className="margin-top margin-bottom">
            We only collect the information you choose to give us, and we process it with your consent.
            We only collect personal or sensitive information that is necessary to fulfil the purpose of
            your interaction with us and use it as our privacy policy describes. You can review our full
            privacy policy at <a href={privacyUrl} target="_blank"><strong>https://www.pjhayman.com/</strong></a>.
            Details are also provided in our terms of business which you will receive with your quote/sales documents.
          </div>
          {/*<RadioBooleanControl*/}
          {/*  title=""*/}
          {/*  name="infoConsent"*/}
          {/*/>*/}
        </div>
      );
    }

    if (['lsb-b2c'].includes(channel.key)) {
      return (
        <div className="margin-top margin-bottom">
          For more information about our service to you and how we will use your information,
          please read our <a href={aboutUsUrl} target="_blank"><strong>Terms of Business</strong> </a>
          and our <a href={privacyUrl} target="_blank"><strong>Privacy Policy</strong></a>.
        </div>
      );
    }

    return (
      <div className="margin-top margin-bottom">
        For more information about our service to you and how we will use your information,
        please read our <a href={aboutUsUrl} target="_blank"><strong>Terms of Business</strong> </a>
        and our <a href={'/privacy'} target="_blank"><strong>Privacy Policy</strong></a>.
      </div>
    );
  }

  private checkForErrorBeforeSubmit = () => {
    const {tripType, startDate, endDate, travellers, actions, product, maxTripDuration, channel} = this.props;
    const start = moment(startDate, 'DD/MM/YYYY');
    const end = moment(endDate, 'DD/MM/YYYY');
    const tripDuration = tripType === 'single' ? end.diff(start, 'days') : maxTripDuration;

    const validationRules = {
      FST: {
        single: [
          {maxTrip: 45, maxAge: 75},
        ],
        annual: [],
      },
      247: {
        single: [
          {maxTrip: 94, maxAge: 80},
        ],
        annual: [],
      },
      VEN: {
        single: [
          {maxTrip: 94, maxAge: 80},
        ],
        annual: [],
      },
      TPL: {
        single: [
          {maxTrip: 35, maxAge: 75},
        ],
        annual: [
          {productCode: 'TPL', maxAge: 79},
        ],
      },
    };

    const validationMessages = {
      TPL: 'Sorry, Travel Plus is unable to provide a quote due to your age.',
    };

    let message;
    const rules = validationRules[product.productCode] && validationRules[product.productCode][tripType] || [];
    const valid = travellers.reduce((carry, traveller) => {
      const travellerAge = this.getAge(traveller.dob);
      return carry && rules.reduce((carry, rule) => {
        if (rule.maxAge) {
          if (travellerAge > rule.maxAge) {
            carry =  rule.maxTrip ? carry && tripDuration <= rule.maxTrip :  carry && travellerAge <= rule.maxAge;
          }
          return carry;
        }
      }, true);
    }, true);
    message = validationMessages[product.productCode] || 'Sorry, ' + channel.name +
      ' is unable to provide a quote online due to your planned trip duration.';

    if (!valid) {
      this.setState({
        showBlockerModal: true,
        modalMessage: message,
      });
    } else {
      actions.submit('quote');
    }
  }

  private closeBlockerModal = () => {
    this.setState({
      showBlockerModal: false,
    });
  }

  private renderBlockerModal = () => {
    const {channel} = this.props;
    const {modalMessage} = this.state;
    const phoneNumber = channel.referralNumber ? channel.referralNumber : channel.phone;

    return (
      <Modal show={this.state.showBlockerModal} onHide={this.closeBlockerModal}>
        <Modal.Header closeButton={true}>
          <Modal.Title>Attention required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>
              <p>
                {modalMessage}
              </p>
              <p>
                Please call our specialist UK-based customer services team
                on <strong>{phoneNumber}</strong> to see if we can provide you with a quote.
              </p>
              <p>
                We are open {channel.openingHours} closed Bank Holidays.
              </p>
            </li>
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle="primary"
            onClick={this.closeBlockerModal}
          >
            CLOSE
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  public render() {
    const {
      i18n,
      submitting,
      tripType,
      handleSubmit,
      destinations,
      valid,
      startDate,
      product,
      destinationsValue,
      renderDefinition,
      submitFailed,
      groupType,
      change,
      channel,
      policyConsent,
    } = this.props;

    const hasAdditionalOption = size(product.metadata[`group_type_trip_${tripType}`]) > 4;

    const covidMessage = get(product.metadata, 'covid_message.travel_detail_b2c', '');

    const regionsList = map(product.metadata.regions, (name, key) => ({
      label: name,
      value: key,
    }));

    const maxTripDurationList = map(product.metadata.annual_trip_durations, (name, key) => ({
      label: name,
      value: key,
    }));

    const maxTripDefinition = product.metadata.definitions.max_trip_duration;

    const showMaxTripSelect = size(maxTripDurationList) > 1;

    const showCruiseCover = ['tam-b2c', 'fst-b2c'].includes(channel.key);
    const showCovidMsg2 = !['fst-b2c', 'tpl-b2c', 'lsb-b2c', '247-b2c', 'ven-b2c'].includes(channel.key);
    const upperCaseList = ['tpl-b2c', 'mpt-b2c', 'lsb-b2c', '247-b2c', 'ven-b2c'];
    const renderTitle = (upperCaseList.indexOf(channel.key) !== -1) ? 'Trip details' : 'TRIP DETAILS';
    let isFreeSpirit = false;

    const maxDateSingle = () => {
      if (channel.key === 'mpt-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('365', 'day');
      }

      if (channel.key === 'fst-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('584', 'day');
      }

      if (channel.key === 'lsb-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('547', 'day');
      }

      if (channel.key === '247-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('94', 'day');
      }

      if (channel.key === 'ven-b2c') {
        return moment(startDate, 'DD/MM/YYYY').add('94', 'day');
      }

      return moment(startDate, 'DD/MM/YYYY').add('93', 'day');
    };

    let isTravelPlus = false;

    if (channel.key === 'tpl-b2c') {
      isTravelPlus = true;
    }

    if (channel.key === 'fst-b2c') {
      isFreeSpirit = true;
    }

    const regionTripType = product.productCode === 'LSB' ? 'longstay' : tripType;
    const isMariners = channel.key === 'mpt-b2c';

    let showSchengenRegionText = false;

    const { region } = this.props;
    if (['europe', 'worldwide', 'worldwide_excluding'].includes(region)) {
      showSchengenRegionText = true;
    }

    const tripDurations = {
      FST: 364,
      TPL: 94,
      MPT: 94,
      LSB: 549,
      247: 94,
      VEN: 94,
    };
    const deferredDays = {
      FST: 548,
      TPL: 365,
      MPT: 365,
      LSB: 365,
      247: 585,
      VEN: 585,
    };

    const filteredTravellers = () => {
      const productMetadata = product.metadata[`group_type_trip_${tripType}`];
      if (!productMetadata) {
        return null;
      }

      const order = ['individual', 'couple', 'family', 'single_parent_family', 'independent_child'];

      return Object.entries(productMetadata)
        .sort(([keyA], [keyB]) => order.indexOf(keyA) - order.indexOf(keyB))
        .reduce((acc, [key, value]) => {
          acc[key] = value;
          return acc;
        }, {} as Record<string, any>);
    };

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div className="steps-container">
          <div className="section-title">
            <h1>{renderTitle}</h1>
          </div>
          {['ven-b2c'].includes(channel.key) && (
            <CovidStatement
              channelKey={channel.key}
              covidMessage={covidMessage}
            />
          )}

          {!['247-b2c', 'ven-b2c'].includes(channel.key) && (
            <CovidStatement
              channelKey={channel.key}
              covidMessage={covidMessage}
            />
          )}

          {!['247-b2c', 'ven-b2c', 'fst-b2c'].includes(channel.key) && (
            <div className="section">
              <FormGroup controlId="trip-type">
                <Row>
                  <Col sm={12}>
                    <Field
                      id="covid-message"
                      name="covidMessage"
                      type="checkbox"
                      component={FieldFormControl}
                      validate={[
                        isRequired,
                      ]}
                    >Please confirm that you have read and agree?&nbsp;
                      <div />
                    </Field>
                  </Col>
                </Row>
              </FormGroup>
            </div>
          )}
          {channel.key === 'lsb-b2c' && (
            <div className="section">
              <FormGroup controlId="trip-type">
                <Row>
                  <Col sm={12}>
                    PLEASE NOTE This is a travel insurance policy and not private medical insurance. This means
                    there is no cover for any medical expenses incurred in private medical facilities if we have
                    confirmed that medically capable public facilities are available.
                  </Col>
                </Row>
              </FormGroup>
            </div>
          )}
          {['tpl-b2c'].includes(channel.key) && (
            <div className="section">
              <FormGroup controlId="trip-type">
                <Row>
                  <Col sm={12}>
                    <Field
                      id="covid-message"
                      name="covidMessageOnBehalf"
                      type="checkbox"
                      component={FieldFormControl}
                      validate={[
                        isRequired,
                      ]}
                    >
                      Can you please confirm that you have the consent of
                      all persons to be insured to act on their behalf?&nbsp;
                      <div />
                    </Field>
                  </Col>
                </Row>
              </FormGroup>
            </div>
          )}
          {size(product.metadata.trip_type) > 0 && (
            <div className="section">
              <FormGroup controlId="trip-type">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      Policy Type:
                      {renderDefinition('trip_type')}
                    </ControlLabel>
                  </Col>
                  <Col sm={9}>
                    <Row className="trip-type-container">
                      {map(product.metadata.trip_type, (name, key) => {
                        return (
                          <Col sm={6} key={key} className="trip-type-btn-container" style={{ marginBottom: '5px' }}>
                            <Field
                              id={`${key}-trip`}
                              name="tripType"
                              type="radio"
                              value={key}
                              component={FieldFormControl}
                            >
                              <div className={'trip-type-btn'}>
                                {name}
                                <FaCheck />
                              </div>
                            </Field>
                          </Col>
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </FormGroup>
            </div>
          )}
          {showCruiseCover && (
            <CruiseQuestion i18n={i18n} channel={channel} />
          )}
          <div className="section">
            {showDestinations(regionTripType) && (
              <FormGroup controlId="destinations">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      Destination(s):
                      {renderDefinition('destinations')}
                    </ControlLabel>
                  </Col>
                  <Col sm={9}>
                    <FieldArray
                      name="destinations"
                      i18n={i18n}
                      destinations={destinations}
                      component={Destination}
                      channel={channel}
                      destinationsValue={destinationsValue}
                      renderDefinition={renderDefinition}
                    />
                  </Col>
                </Row>
              </FormGroup>
            )}
            {showCovidMsg2 && (
              <FormGroup>
                <Row>
                  <Col sm={12}>
                    <ControlLabel style={{ color: '#c22116' }}>
                      Following the outbreak of coronavirus (COVID-19), there will be no cover for cancellation,
                      abandonment, or
                      curtailment claims if the Foreign and Commonwealth Office (FCO) advises you not to travel, for
                      example
                      where the FCO advise against all but essential travel to an area affected by Coronavirus,
                      COVID-19, Severe
                      Acute Respiratory Syndrome (SARS-COV-2) or any mutation of Coronavirus, COVID-19 or SARs-COV-2.
                    </ControlLabel>
                  </Col>
                </Row>
              </FormGroup>
            )}
            {showRegions(regionTripType) && (
              <FormGroup controlId="region">
                <Row>
                  <Col sm={3}>
                    <ControlLabel>
                      Region:
                      {renderDefinition('region')}
                    </ControlLabel>
                  </Col>
                  <Col sm={9}>
                    <Field
                      name="region"
                      id="region-select"
                      type="text"
                      component={SelectControl}
                      options={regionsList}
                      validate={[
                        isRequired,
                      ]}
                    />
                  </Col>
                  <Col sm={3}>
                  </Col>
                  <Col sm={9}>
                    {showSchengenRegionText && (
                      <p style={{ fontSize: '14px', marginTop: '10px' }}>
                        This policy will include cover to all destinations within the Schengen Area. For further
                        information on Schengen travel requirements, you can visit the Gov.uk website here:
                        <a href="https://www.gov.uk/travel-to-eu-schengen-area" target="_blank">
                          https://www.gov.uk/travel-to-eu-schengen-area</a>
                      </p>
                    )}
                  </Col>
                </Row>
              </FormGroup>
            )}

            {showMaxTripSelect && showRegions(tripType) && (
              <FormGroup controlId="maxTripDuration">
                <MaxTripDuration
                  i18n={i18n}
                  options={maxTripDurationList}
                  definition={maxTripDefinition}
                  renderDefinition={renderDefinition}
                />
              </FormGroup>
            )}

          </div>
          <div className="section">
            <FormGroup controlId="start-date">
              <Row>
                <Col componentClass={ControlLabel} sm={3}>
                  Start date:
                  {showDestinations(tripType) ? renderDefinition('travel_dates_single_start_date') :
                    renderDefinition('travel_dates_annual')}
                </Col>
                <Col sm={6}>
                  <div className="alternative-date-picker">
                    <div className="field">
                      <Field
                        name="startDate"
                        id="start-date-text-field"
                        type="masked-date"
                        placeholder="dd/mm/yyyy"
                        component={FieldFormControl}
                      />
                    </div>
                    <div className="icon">
                      <Field
                        name="startDate"
                        minDate={moment()}
                        maxDate={showRegions(tripType)
                          ? moment().add('30', 'days')
                          : moment().add((deferredDays[product.productCode] || 366), 'days')
                        }
                        component={AlternativeDatePicker}
                        validate={showRegions(tripType) ? [
                          isRequired,
                          isFutureDate,
                          isValidDate,
                          annualLimit,
                        ] : [
                          isRequired,
                          isFutureDate,
                          isValidDate,
                          singleLimit(deferredDays[product.productCode] || 94),
                        ]}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </FormGroup>
            {tripType === 'annual' && (
              <Row className="important">
                <strong>IMPORTANT</strong> - Cancellation cover begins on the date you choose
                to start your policy. If you already have a trip booked and you want to be covered
                immediately, you should select today’s date. You can choose to start your policy
                later (up to 31 days from today’s date) but there would not be any cancellation
                cover between now and the start date you choose.
              </Row>
            )}
            {tripType === 'single' && (
              <FormGroup controlId="end-date">
                <Row>
                  <Col componentClass={ControlLabel} sm={3}>
                    Return date: {renderDefinition('travel_dates_single_end_date')}
                  </Col>
                  <Col sm={6}>
                    <div className="alternative-date-picker">
                      <div className="field">
                        <Field
                          name="endDate"
                          type="masked-date"
                          id="end-date-text-field"
                          placeholder="dd/mm/yyyy"
                          component={FieldFormControl}
                        />
                      </div>
                      <div className="icon">
                        <Field
                          name="endDate"
                          minDate={startDate ? moment(startDate, 'DD/MM/YYYY') : moment()}
                          maxDate={startDate ? maxDateSingle() : moment()}
                          component={AlternativeDatePicker}
                          validate={isMariners ? [
                              isRequired,
                              isFutureDate,
                              isValidDate,
                            ] :
                            [
                              isRequired,
                              isFutureDate,
                              isValidDate,
                              // minTripDuration(startDate),
                              singleMaxTripDuration(startDate, tripDurations[product.productCode] || 365),
                            ]
                          }
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </FormGroup>
            )}
          </div>
          <div className="section">
            <FormGroup controlId="group-type">
              <Row>
                <Col sm={3}>
                  <ControlLabel>
                    <div className="non-break-label">
                      Travellers Details:{renderDefinition('group_type')}
                    </div>
                  </ControlLabel>
                </Col>

                <Col sm={hasAdditionalOption ? 12 : 9}>
                  <Row className="group-type-radio">
                    {map(filteredTravellers(), (name, key) => {
                      return (
                        <Col xs={6} sm={6} md={hasAdditionalOption ? 2 : 3} key={key}>
                          <Field
                            name="groupType"
                            type="radio"
                            id={key}
                            value={key}
                            component={FieldFormControl}
                            validate={[isRequired]}
                          >
                            <div>
                              <GroupType channel={channel.key} name={key} />
                              <GroupTypeSelected channel={channel.key} name={key} />
                            </div>
                            {name}
                          </Field>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            </FormGroup>
          </div>
          <FieldArray
            name="travellers"
            i18n={i18n}
            product={product}
            component={Travellers}
            groupType={groupType}
            renderDefinition={renderDefinition}
            change={change}
          />
          <VoucherCode {...this.props} />
          <div className="section">
            <Row style={{ marginBottom: '10px', marginTop: '-5px' }}>
              <Col sm={12}>
                <Field
                  name="whereDidYouHearAboutUs"
                  type="text"
                  placeholder={'How did you hear about us?'}
                  component={FieldFormControl}
                />
              </Col>
            </Row>
          </div>
          <div className="section">
            <Row>
              <MarketingOptions />
            </Row>
          </div>
          <div>
            <div className="aboutUs">
              {this.renderAboutUs()}
            </div>
            {isTravelPlus && (
              <Row>
                <Col sm={12}>
                  <p>
                    Travel Plus and Canopius Managing Agents Limited, need your consent to use the sensitive details
                    about you in connection with your insurance, Where you have provided us details about other people,
                    we and other insurance market participants also need their consent to use the sensitive details
                    about them in connection with your insurance over. We need you to make sure you have obtained their
                    consent before you proceed.
                  </p>
                </Col>
                <Col sm={1}>
                  <Field
                    name="policyConsent"
                    type="checkbox"
                    component={FieldFormControl}
                    validate={[
                      isRequired,
                      isNotFalse,
                    ]}
                  >
                    <div />
                  </Field>
                </Col>
                <Col sm={11}>
                  Please tick to confirm you have read and understand the above statement and are happy to proceed on
                  this basis.
                </Col>
              </Row>
            )}
          </div>
          <div>
            {isFreeSpirit && (
              <Row>
                <Col sm={12}>
                  <p>
                    Free Spirit and Canopius Managing Agents Limited, need your consent to use the sensitive details about you in connection with your insurance. Where you have provided us details about other people, we and other insurance market participants also need their consent to use the sensitive details about them in connection with your insurance over. We need you to make sure you have obtained their consent before you proceed.
                  </p>
                </Col>
                <Col sm={1}>
                  <Field
                    name="policyConsent"
                    type="checkbox"
                    component={FieldFormControl}
                    validate={[
                      isRequired,
                      isNotFalse,
                    ]}
                  >
                    <div />
                  </Field>
                </Col>
                <Col sm={11}>
                  Please tick to confirm you have read and understand the above statement and are happy to proceed on
                  this basis.
                </Col>
              </Row>
            )}
          </div>
          <div className="btn-bar margin-top">
            <Button
              id="continue"
              bsStyle="primary"
              className="pull-right"
              onClick={this.checkForErrorBeforeSubmit}
              disabled={submitting || (submitFailed && !valid) || (!policyConsent && isTravelPlus)}
            >
              Continue <FaChevronRight />
            </Button>
          </div>
        </div>
        {
          this.renderBlockerModal()
        }
      </Form>
    );
  }
}

let selector;
let previousValues;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onChange: (
      values: IPolicyApplication,
      dispatch,
      props: ITripDetailsFormProps,
    ) => {
      if (!previousValues) {
        previousValues = values;
        return;
      }

      let recalculateScore = false;

      if (difference(values.destinations, previousValues.destinations).length > 0) {
        recalculateScore = true;
      }

      if (values.region !== previousValues.region) {
        recalculateScore = true;
      }

      if (recalculateScore) {
        props.actions.quote.recalculateScreening();
      }

      previousValues = values;
    },
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const groupType = selector(state, 'groupType');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const destinationsValue = selector(state, 'destinations');
      const occupationValue = selector(state, 'occupations');
      const industryValue = selector(state, 'industries');
      const region = selector(state, 'region');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const residency = selector(state, 'residency');
      const quotationTypes = selector(state, 'quotationTypes');
      const schemeId = selector(state, 'schemeId');
      const cruiseCover = selector(state, 'cruiseCover');
      const travellers = selector(state, 'travellers');
      const policyConsent = selector(state, 'policyConsent');
      const infoConsent = selector(state, 'infoConsent');

      return {
        cruiseCover,
        tripType,
        quotationTypes,
        residency,
        region,
        maxTripDuration,
        groupType,
        startDate,
        schemeId,
        endDate,
        destinationsValue,
        occupationValue,
        industryValue,
        travellers,
        policyConsent,
        infoConsent,
        auth: state.auth,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(TripDetailsForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/index.tsx